import type { Locale } from "@iso27001/shared";

/**
 * Renders an ISO `YYYY-MM-DD` version date in the reader's language.
 *
 * Deliberately string-only, in both languages. The obvious
 * `new Date(iso).toLocaleDateString(...)` parses a bare date as UTC midnight
 * and then formats it in the viewer's zone, so anyone west of Greenwich sees a
 * document approved on 25.10.2024 dated 24.10.2024. A Freigabedatum is a
 * calendar date off a paper document — it has no time and no zone, and must not
 * acquire one on the way to the screen.
 */
export function formatVersionDate(iso: string | null, locale: Locale): string | null {
  if (!iso) return null;
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(iso);
  if (!m) return null;
  return locale === "de" ? `${m[3]}.${m[2]}.${m[1]}` : `${m[1]}-${m[2]}-${m[3]}`;
}
